<template>
  <div class="flex items-center gap-[8px] p-[12px]">
    <img
      :src="activePlatform.logo"
      :alt="activePlatform.label"
      class="w-auto h-[24px]"
    >
    <span class="text-[14px] text-[#333333] text-left select-all">{{ orderNumber }}</span>
  </div>
</template>

<script>
import { MARKETPLACE_PLATFORM } from './config'

export default {
  name: 'MarketplacePlatformCell',
  props: {
    platform: {
      type: String,
      required: false,
      default: 'kompack',
    },
    orderNumber: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    activePlatform() {
      return MARKETPLACE_PLATFORM[this.platform]
    },
  },
}
</script>
